module.exports = __webpack_public_path__ + "static/pp_dane_o-bead5f716ee7869921ac328d70d690b0.gif";